module.exports = __webpack_public_path__ + "static/media/empty-state-user-not-found.28a0b090.svg";